<script setup lang="ts">
  import FillActions from './FillActions.vue';
  import LabSection from './LabSection.vue';
  import SavedResponsesList from './SavedResponsesList.vue';
</script>

<template>
  <LabSection
    title="Preenchimento"
    open
    data-testid="lab-archive"
    hint="O que a pessoa que preenche vê ao lado da folha: salvar, tentar arquivar e os avisos do próprio formulário."
  >
    <FillActions />
    <SavedResponsesList />
  </LabSection>
</template>
